import useSWRImmutable from 'swr/immutable';
import { getContentByGQL, isGQLErrorResponse } from '@belong/contentful';
import { logger } from '@belong/logging';
import { ICatalogOffer } from '@belong/types';
import { ILoadOfferDetailsResponse, loadOfferDetailsGql } from '../queries/loadOfferDetails.gql';
import { FCatalogOffer } from '../factories';

export interface IUseOfferDetails {
  isLoading: boolean;
  error?: Error;
  offer?: ICatalogOffer;
}

const loadOfferDetails = async (offerId: string): Promise<ICatalogOffer> => {
  const result = await getContentByGQL<ILoadOfferDetailsResponse>(loadOfferDetailsGql, {
    ids: [offerId]
  });

  // Check for errors
  if (isGQLErrorResponse(result)) {
    throw new Error(JSON.stringify(result.errors));
  }

  // Check for empty result
  if (!result.data?.catalogOfferCollection.items.length) {
    throw new Error('Offer not found');
  }

  return FCatalogOffer(result.data?.catalogOfferCollection.items[0]);
};

// Look up offer details in the CMS by offer id
// Note: Using SWRImmutable to prevent re-fetching/revalidation on tab change or focus
export const useOfferDetails = (offerId: string, shouldFetch: boolean): IUseOfferDetails => {
  const {
    isLoading,
    error,
    data: offer
  } = useSWRImmutable(shouldFetch ? offerId : false, () => loadOfferDetails(offerId));

  if (error) {
    logger.error('[useOfferDetails]', error);
  }

  return {
    isLoading,
    error,
    offer
  };
};
